angular.module('rjmNg.directives').directive "commonDropdown", [
  () ->
    restrict: "E"
    templateUrl: "directive.commonDropdown.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      itemList: '<',
      selectFn: '&',
      selectedItem: '<',
      cdDependent: '<',
      cdDisabled : '<',
      cdName: '@',
      cdProp: '@',
      cdSearch: '<'
    controller: [() ->
        view = @
        view.filterFn = (val, ix, arr) ->
          result = true
          if(view.search)
            result = val[view.cdProp].toLowerCase().indexOf(view.search.toLowerCase()) isnt -1
          return result

        view.$postLink = () ->
          view.cdProp ?= 'name'
          view.cdSearch ?= true

        return view
    ]
]
